import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MsalModule } from '@azure/msal-angular';
import { AuthService } from '../core-services/authentication/auth.service';
import { HeaderComponent } from './shared/header/header.component';
import { CommonModule } from '@angular/common';
import { EmployeeInfoService } from 'src/core-services/core/employee-info.service';

@Component({
  selector: 'app-root',
  imports: [HeaderComponent, CommonModule, RouterOutlet, MsalModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true
})
export class AppComponent implements OnInit {
  title = 'Be Well Together';
  roles: string = '';
  isLoading: boolean = true;
  hideHeaderFooter: boolean = true;

  constructor(private router: Router, private authService: AuthService, private employeeInfoService: EmployeeInfoService) {
    this.isLoading = true;
  }

  ngOnInit(): void {
    this.authService.authRedirect().subscribe(() => {     
      // console.log('Authentication successful:', result);
      if (this.authService.isUserAuthenticated()) {
        this.hideHeaderFooter = false;
        this.initiateApplication()
        this.isLoading = false;
        // this.loginRedirect();
      }
      else{
        this.hideHeaderFooter = true;
        this.isLoading = false;
      }
    });
  }

  initiateApplication() {
    const userId = this.authService.getUserDetails().enterpriseId;
    this.employeeInfoService.fetchRoles(userId).subscribe({
      next: (dta: any) => {
        // console.log('roles from api --> app.component.ts: ', dta);
        const role = dta?.MessageBody?.Role;
        const roles = Array.isArray(role) ? role : [role || '']; // Ensure roles is an array
        const menu = dta?.MessageBody?.RoleMenus;
        // console.log('RAW RoleMenus:', menu);

        const menus = Array.isArray(menu) ? menu : [menu || ''];
        // console.log('Menu from response:', menus);

        this.authService.setRoles(roles);
        this.authService.setMenu(menus);
        this.loginRedirect();
      },
      error: (err) => {
        console.error('Error fetching roles in app.component.ts:', err);
       //   this.router.navigate(['/unauthorized']);
      }
    });
  }


  loginRedirect() {
    if (this.authService.getRoles().length > 0) {  
      if(this.authService.getRoles().includes('unauthorized'))
        this.authService.logout();
      else
        this.router.navigate(['/home'])
    }
    else {
      this.router.navigate(['/unauthorized']);
    }
  }
}